import React from "react";
import { Query } from "react-apollo";
import { css } from "glamor";
import * as R from "ramda";

import { DescriptionList } from "ant-design-pro";
import WithAuth from "../../container/WithAuth";
import { BASE_URL } from "../../config";
import { countryIsoCodeToName } from "../../formatters";
import { withApolloState } from "../../util";
import EditResearchRequestForm from "./EditResearchRequestForm";
import { VIEW_RESEARCH_REQUEST } from "./queries";

const styles = {
    topbarTitle: css({
        fontSize: 24,
        fontWeight: "bold",
    }),
};

const generateConflictDescription = () => `
    We've not been able to renew your research
    request because there is an incomplete request
    for this entity. Please edit it to obtain
    more/additional information.
    `;

const Title = ({ entity, title }) => {
    const entityType = entity.humanEntityType || entity.entityType;

    const countryCode = R.pathOr(
        "",
        [
            entity.entityType === "ORGANISATION"
                ? "legalAddress"
                : "physicalAddress",
            "countryCode",
        ],
        entity
    );

    return (
        <div>
            <div className={styles.topbarTitle}>
                {title} for {entity.name}
            </div>
            <DescriptionList size="small" gutter={2} col={2}>
                <DescriptionList.Description term="Type">
                    {entityType}
                </DescriptionList.Description>
                <DescriptionList.Description term="Country">
                    {countryIsoCodeToName(countryCode)}
                </DescriptionList.Description>
            </DescriptionList>
        </div>
    );
};

const EditResearchRequest = props => (
    <Query
        query={VIEW_RESEARCH_REQUEST}
        fetchPolicy="cache-and-network"
        variables={{
            id: btoa("ResearchRequest:" + props.match.params.ulid),
        }}
    >
        {withApolloState(apolloProps => {
            const { researchRequest } = apolloProps.data;
            return (
                <EditResearchRequestForm
                    {...props}
                    researchRequest={researchRequest}
                    conflictTitle="Error!"
                    getConflictDescription={generateConflictDescription}
                    titlePlacement="bluebar-left-content"
                    title={<Title entity={researchRequest.entity} {...props} />}
                    renewUlid={props.match.params.ulid}
                    actionUrl={`${BASE_URL}/api/tickets/${props.match.params.ulid}/${props.action}/`}
                    disable={{
                        entity_name: true,
                        entity_type: true,
                        country_code: true,
                        monitoring_type: true,
                    }}
                />
            );
        })}
    </Query>
);

export default WithAuth(EditResearchRequest);
